var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc-box",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"desc-content"},[_vm._v(" "+_vm._s(_vm.curTagInfo.description)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }